export let Baseurl="https://devapi.theartofmindfulliving.com/api"



export let getUserdata=JSON.parse(localStorage.getItem("m_authdata"))
export let imagebaseurl="https://devapi.theartofmindfulliving.com/public/upload/profile_img/"
export let iconbaseurl="https://devapi.theartofmindfulliving.com/public/upload/icons"
 export let audiocoverurl="https://devapi.theartofmindfulliving.com/public//upload/audio_cover_img/"
 export let videocoverurl="https://devapi.theartofmindfulliving.com/public/upload/video_thumb/"
 export let blogscoverurl="https://devapi.theartofmindfulliving.com/public/upload/blog_cover_img/"

 export let Ebokscoverurl="https://devapi.theartofmindfulliving.com/public/upload/ebooks_category_img/"
 export let EboksVideourl="https://devapi.theartofmindfulliving.com/public/upload/ebooks_video_file/"

export let groupe_scoverurl="https://devapi.theartofmindfulliving.com/public/upload/group_sessions/"
export let User_Profileimage="https://devapi.theartofmindfulliving.com/public/upload/profile_img/"

 
export let Coach_imageUrl="https://devapi.theartofmindfulliving.com/public/upload/coach_img"
 